import {takeEvery, all, call} from 'redux-saga/effects';
import {setArtworks, retryArtwork, deleteArtwork, deliverableArtwork} from './workers';
import {
    CONTENT_ITEM_VIEW_ARTWORK_GET,
    CONTENT_ITEM_VIEW_ARTWORK_RETRY,
    CONTENT_ITEM_VIEW_ARTWORK_DELETE,
    CONTENT_ITEM_VIEW_ARTWORK_DELIVERABLE,
} from '../ContentItemViewArtworkActions';

function* watchSetArtworkWorker() {
    yield takeEvery(CONTENT_ITEM_VIEW_ARTWORK_GET, setArtworks);
}

function* watchRetryArtworkWorker() {
    yield takeEvery(CONTENT_ITEM_VIEW_ARTWORK_RETRY, retryArtwork);
}

function* watchDeleteArtworkWorker() {
    yield takeEvery(CONTENT_ITEM_VIEW_ARTWORK_DELETE, deleteArtwork);
}

function* watchDeliverableArtworkWorker() {
    yield takeEvery(CONTENT_ITEM_VIEW_ARTWORK_DELIVERABLE, deliverableArtwork);
}

export function* watchContentItemViewArtwork() {
    yield all([
        call(watchSetArtworkWorker),
        call(watchRetryArtworkWorker),
        call(watchDeleteArtworkWorker),
        call(watchDeliverableArtworkWorker),
    ]);
}
